import { ArrowLeft, Compass } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router";

import { Button } from "@/components/ui/button";
import { isValidLang } from "@/config/routes";

export function NotFoundPage() {
	const { t } = useTranslation();
	const { lang } = useParams<{ lang: string }>();
	const validLang = lang && isValidLang(lang) ? lang : "pl";

	return (
		<div className="flex min-h-svh w-full items-center justify-center bg-background p-6 md:p-10">
			<div className="flex max-w-md flex-col items-center text-center">
				<div className="mb-6 flex size-20 items-center justify-center rounded-2xl bg-muted">
					<Compass
						aria-hidden="true"
						className="size-10 text-muted-foreground"
					/>
				</div>

				<p className="mb-2 text-sm font-medium tracking-widest text-muted-foreground uppercase">
					404
				</p>

				<h1 className="mb-3 text-2xl font-semibold tracking-tight text-foreground">
					{t("notFound.title")}
				</h1>

				<p className="mb-8 text-sm leading-relaxed text-muted-foreground">
					{t("notFound.description")}
				</p>

				<Button variant="ghost" asChild>
					<Link to={`/${validLang}`}>
						<ArrowLeft aria-hidden="true" className="size-4" />
						{t("notFound.backHome")}
					</Link>
				</Button>
			</div>
		</div>
	);
}
